import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import Delete from '@mui/icons-material/Delete';

import {
  AppBar,
  Button as Btn,
  ButtonGroup,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  ChunkedFileUploader,
  ColourPicker,
  DatePicker,
  Editor,
  IconButton,
  ImagePicker,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { AppointmentType } from '../../../models/AppointmentType';
import { CoachSkill } from '../../../models/CoachSkill';
import { KnowledgeCourse } from '../../../models/KnowledgeCourse';
import { Questionnaire } from '../../../models/Questionnaire';
import { Segment } from '../../../models/Segment';

import HelpersLanguage from '../../../actions/helpers/language';
import DeleteForever from '@mui/icons-material/DeleteForever';

const { DateTime } = require("luxon");

type Props = {}

export const CoachCourseEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  // const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [isReturn, setIsReturn] = useState<string | undefined>(params.r);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [mainObject, setMainObject] = useState<KnowledgeCourse>({
    name: '',
    mollie_data: {
      cost: '0.0'
    },
    access_data: {
      main_access: 'client',
      availability: [1],
      client: {
        level: 'none',
        past_months: 6,
        app_type_ids: []
      },
      coach: {
        level: 'none'
      }
    }
  });
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [currentLanguage, setCurrentLanguage] = useState<string>('nl');
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [clapped, setClapped] = useState<number[]>([]);
  const [itemCleared, setItemCleared] = useState<boolean>(false);
  const [bgItemCleared, setBgItemCleared] = useState<boolean>(false);
  const [item, setItem] = useState<File>();
  const [bgItem, setBgItem] = useState<File>();
  const [bgItemUrl, setBgItemUrl] = useState<string>();
  const [isUploading, setIsUploading] = useState<{[s:string]: boolean}>();

  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["knowledge_course", (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          id: objectId,
          fields: [
            'id', 'name', 'teaser', 'body', 'extra_data', 'access_data', 'mollie_data', 'get_item',
            'get_video', 'enabled', 'is_hidden', 'is_frontpage', 'is_open_order', 'is_emails', 'is_approvable',
            'review_id', 'quiz_id', 'segment_id', 'full_body', 'full_name', 'full_teaser', 'is_bg_color',
            'is_nutri', 'is_it', 'weight', 'course_type'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: questionnaires,
    // isLoading: objectsLoading,
    // isError: objectsError,
    isSuccess: questionnairesSuccess,
    refetch: questionnairesRefetch,
  } = useQuery({
    queryKey: ["coach", "questionnaires", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all<Questionnaire>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'questionnaire',
          fields: ['id', 'name', 'content_type'],
          order: 'name ASC',
          per_page: 200,
          page: 0,
          filter: {
            search: '',
            advanced: {
              only_for_knowledge: 1,
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          },
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!(login?.practice_id || currentPractice?.id),
  });

  const {
    data: segments,
    isLoading: segmentsLoading,
    isError: segmentsError,
    isSuccess: segmentsSuccess,
    // refetch: segmentsRefetch,
  } = useQuery({
    queryKey: ["segments", currentPractice?.id],
    queryFn: () =>
      fetch_all<Segment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'segment',
          fields: ['id', 'name'],
          order: "name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });








  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["coach", "knowledge_courses", (login?.practice_id || currentPractice?.id)] });
      if (!!isReturn) {
        navigate(`/knowledge_course/${mainObject.id}/builder`);
      } else {
        if (!variables.keepOpen) navigate("/knowledge_courses");
        if (!!variables.keepOpen && objectId === 'new') navigate(`/knowledge_course/${data.id}`);
        if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
      }
    },
  });





  const saveObject = (keep_open: boolean) => {
    let data = new FormData();
    data.append('object', 'knowledge_course');
    data.append('handler_id', login?.id?.toString() || '');
    data.append('practice_id', (login?.practice_id || currentPractice?.id || '').toString() || '');
    if (!!mainObject?.id) data.append('id', mainObject?.id?.toString() || '');
    if (!!mainObject?.id) data.append('ob[id]', mainObject?.id?.toString() || '');
    data.append('ob[practice_id]', (login?.practice_id || currentPractice?.id || '').toString() || '');
    if (!!mainObject.item) {
      data.append(`ob[item]`, mainObject.item);
    }
    data.append(`fields[]`, 'id');
    // if (!!mainObject.video) {
    //   data.append(`ob[video]`, mainObject.video);
    // }
    data.append('ob[body]', (mainObject.full_body || {})[1]?.toString() || '');
    data.append('ob[name]', (mainObject.full_name || {})[1]?.toString() || '');
    data.append('ob[teaser]', (mainObject.full_teaser || {})[1]?.toString() || '');
    data.append('ob[extra_data][is_background_colour]', mainObject.extra_data?.is_background_colour === '1' ? '1' : '0');
    data.append('ob[extra_data][background_colour]', mainObject.extra_data?.background_colour || '');
    data.append('ob[enabled]', !!mainObject.enabled ? '1' : '0');
    data.append('ob[is_hidden]', !!mainObject.is_hidden ? '1' : '0');
    data.append('ob[is_frontpage]', !!mainObject.is_frontpage ? '1' : '0');
    data.append('ob[weight]', mainObject.weight?.toString() || '100');
    data.append('ob[course_type]', mainObject.course_type?.toString() || '0');
    data.append('ob[is_approvable]', !!mainObject.is_approvable ? '1' : '0');
    data.append('ob[mollie_data][cost]', mainObject.mollie_data?.cost || '');
    data.append('ob[mollie_data][immediate_payment]', mainObject.mollie_data?.immediate_payment?.toString() === '1' ? '1' : '0');
    data.append('ob[segment_id]', mainObject?.segment_id?.toString() || '');
    data.append('ob[is_open_order]', !!mainObject.is_open_order ? '1' : '0');
    data.append('ob[is_nutri]', !!mainObject.is_nutri ? '1' : '0');
    data.append('ob[is_it]', !!mainObject.is_it ? '1' : '0');
    data.append('ob[extra_data][numerals]', mainObject.extra_data?.numerals || 'normal');
    data.append('ob[is_emails]', !!mainObject.is_emails ? '1' : '0');
    data.append('ob[review_id]', mainObject?.review_id?.toString() || '');
    data.append('ob[quiz_id]', mainObject?.quiz_id?.toString() || '');
    // data.append('ob[access_data][availability]', mainObject.access_data?.availability || '');
    data.append('ob[access_data][months_available]', mainObject.access_data?.months_available?.toString() || '0');

    (mainObject.access_data?.availability || [1]).map((lang_id, i) => {
      data.append(`ob[access_data][availability][]`, lang_id.toString() || '');
    });
    Object.keys(mainObject.extra_data?.video_url || {}).map((lang) => {
      data.append(`ob[extra_data][video_url][${lang}]`, (mainObject?.extra_data?.video_url || {})[lang] || '');
    });

    Object.keys(mainObject.full_body || {}).map((key) => {
      if (parseInt(key, 10) !== 1) {
        data.append(`translations[body][${key}]`, (mainObject.full_body || {})[parseInt(key, 10)]?.toString() || '');
      }
    });
    Object.keys(mainObject.full_name || {}).map((key) => {
      if (parseInt(key, 10) !== 1) {
        data.append(`translations[name][${key}]`, (mainObject.full_name || {})[parseInt(key, 10)]?.toString() || '');
      }
    });
    Object.keys(mainObject.full_teaser || {}).map((key) => {
      if (parseInt(key, 10) !== 1) {
        data.append(`translations[teaser][${key}]`, (mainObject.full_teaser || {})[parseInt(key, 10)]?.toString() || '');
      }
    });
    let cntr = 0;
    (mainObject.mollie_data?.coupons || []).forEach(cpn => {
      if (!!cpn.name && !!cpn.perc && !!cpn.date) {
        data.append(`ob[mollie_data][coupons][${cntr}][name]`, cpn.name);
        data.append(`ob[mollie_data][coupons][${cntr}][perc]`, cpn.perc?.toString());
        data.append(`ob[mollie_data][coupons][${cntr}][date]`, cpn.date);
        cntr += 1;
      }
    });
    
    mutationSave.mutate({
      formData: data,
      keepOpen: keep_open
    });
  };

  let page_title;
  if (typeof((object || {}).id) === 'undefined') {
    page_title = t("general.titles.add", "Nieuwe") + " " + t("coach.models.knowledge_courses.singular", "Cursus");
  } else {
    page_title = t("general.titles.edit", "Wijzig") + " " + (object || {}).name;
  }

  useEffect(() => {
    setObjectId(params.id);
    if (params.id !== 'new') objectRefetch();
  }, [params.id]);
  useEffect(() => {
    if (!!objectSuccess) setMainObject({
      ...object,
      extra_data: {
        ...(object.extra_data || {}),
        is_background_colour: !!(object.is_bg_color || false) ? '1' : '0'
      },
      access_data: {
        ...(object.access_data || {}),
        availability: ((object.access_data || {}).availability || ['1']).map(mmm => parseInt(mmm?.toString(), 10))
      }
    });
  }, [object]);
  useEffect(() => {
    let err:any = {};
    if (!mainObject.name) err.name = true;
    // if ((mainObject.extra_data?.questions || []).length < 1) err.questions = true;

    setErrors(err);
  }, [mainObject]);
  useEffect(() => {
    setIsReturn(searchParams.get("r") || undefined);
  }, [searchParams.get("r")]);

  return <Page
    title={page_title}
    titleCrumbs={[
      {
        title: t("coach.menu.knowledge_courses", "Cursussen"),
        path: "/knowledge_courses"
      }
    ]}
  >
    <Paper sx={{padding: 2}}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.course_sections.basic")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
            <Tabs value={currentLanguageId} onChange={(ev, i) => {
              setCurrentLanguageId(i);
              setFlickerEditor(true);
              setTimeout(() => {setFlickerEditor(false);}, 200);
            }}>
              {HelpersLanguage.available_locales().map((locale, i) => {
                return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
              })}
            </Tabs>
          </AppBar>
        </Grid>
        <Grid item xs={12} md={6} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <TextInput
            id="name"
            caption={t("general.knowledge_courses.fields.name")}
            starred
            value={(mainObject?.full_name || {})[currentLanguageId] || ""}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_name: {
                  ...(mainObject.full_name || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <TextInput
            id="teaser"
            caption={t("general.knowledge_courses.fields.teaser")}
            starred
            multiline
            value={(mainObject?.full_teaser || {})[currentLanguageId] || ""}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_teaser: {
                  ...(mainObject.full_teaser || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.course_type")}
            backend
            id="course_type"
            value={mainObject.course_type?.toString() || '0'}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                course_type: !!v ? parseInt(v.toString(), 10) : 0
              });
            }}
          >
            <MenuItem value="0">{t("general.knowledge_courses.fields.course_types.elearning")}</MenuItem>
            <MenuItem value="1">{t("general.knowledge_courses.fields.course_types.general_knowledge")}</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={(mainObject?.extra_data?.is_background_colour || '0') !== '1' ? 2 : 4}>
          <Switcher
            id="is_background_colour"
            caption={t("general.knowledge_courses.fields.is_background_colour")}
            value={(mainObject?.extra_data?.is_background_colour || '0') === '1'}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject?.extra_data || {}),
                  is_background_colour: !!c ? '1' : '0'
                }
              });
            }}
          />
        </Grid>
        {(mainObject?.extra_data?.is_background_colour || '0') === '1' && <Grid item xs={12} md={4}>
          <ColourPicker
            label={t("general.knowledge_courses.fields.background_colour")}
            value={mainObject?.extra_data?.background_colour || 'rgba(0, 0, 0, 0.4)'}
            onChange={(v) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject?.extra_data || {}),
                  background_colour: v
                }
              });
            }}
          />
        </Grid>}
        {(mainObject?.extra_data?.is_background_colour || '0') !== '1' && <Grid item xs={12} md={6}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.background_image")}</Typography>
          <ImagePicker
            existing={mainObject?.get_item}
            deleteable
            backend
            item={bgItem}
            itemUrl={bgItemUrl}
            onSelect={(_item:File|undefined, _itemUrl:string|undefined) => {
              setBgItem(_item);
              setBgItemUrl(_itemUrl);
              setMainObject({
                ...mainObject,
                item: _item,
                itemUrl: _itemUrl
              });
              if (!_item && !_itemUrl) {
                setBgItemCleared(true);
              } else {
                setBgItemCleared(false);
              }
            }}
          />
        </Grid>}
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.content")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
            <Tabs value={currentLanguageId} onChange={(ev, i) => {
              setCurrentLanguageId(i);
              setFlickerEditor(true);
              setTimeout(() => {setFlickerEditor(false);}, 200);
            }}>
              {HelpersLanguage.available_locales().map((locale, i) => {
                return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
              })}
            </Tabs>
          </AppBar>
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.body")} *</Typography>
          {!flickerEditor && <Editor
            knowledge
            label=""
            value={(mainObject?.full_body || {})[currentLanguageId] || ""}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_body: {
                  ...(mainObject.full_body || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />}
        </Grid>
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.video")}</Typography>
          <Divider />
        </Grid>
        {HelpersLanguage.available_locales().map((locale, i) => <Grid item xs={12} md={6}>
          <ChunkedFileUploader
            caption={`${t("general.knowledge_courses.fields.video")} (${locale})`}
            fileInputName={`video${mainObject?.id || 'new'}_${locale}`}
            accept='video/*'
            current={((mainObject.extra_data || {}).video_url || {})[locale]}
            onChange={(url) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject.extra_data || {}),
                  video_url: {
                    ...((mainObject.extra_data || {}).video_url || {}),
                    [locale]: url
                  }
                }
              });
            }}
            onChangeIsUploading={(b) => {
              setIsUploading({
                ...isUploading,
                [locale]: b
              });
            }}
          />
          {!!((mainObject.extra_data || {}).video_url || {})[locale] && <Btn
            size="small"
            sx={{marginLeft: 1}}
            color="secondary"
            onClick={() => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject.extra_data || {}),
                  video_url: {
                    ...((mainObject.extra_data || {}).video_url || {}),
                    [locale]: ''
                  }
                }
              });
            }}
          >{t("general.terms.clear_field")}</Btn>}
        </Grid>)}
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.general")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="enabled"
            caption={t("general.knowledge_courses.fields.enabled")}
            value={!!mainObject?.enabled}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                enabled: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="hidden"
            caption={t("general.knowledge_courses.fields.is_hidden")}
            value={!!mainObject?.is_hidden}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_hidden: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_frontpage"
            caption={t("general.knowledge_courses.fields.is_frontpage")}
            value={!!mainObject?.is_frontpage}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_frontpage: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput
            id="weight"
            disabled={!mainObject.is_frontpage}
            caption={t("general.knowledge_courses.fields.weight")}
            value={mainObject?.weight?.toString() || "100"}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                weight: !!e ? parseInt(e, 10) : 100
              });
            }}
          />
        </Grid>
        {((login?.practice_id || currentPractice?.id) === 4 || (login?.practice_id || currentPractice?.id) === 13 || (login?.practice_id || currentPractice?.id) === 455) && <Grid item xs={12} md={4}>
          <Switcher
            id="is_nutri"
            caption={t("general.knowledge_courses.fields.is_nutri")}
            value={!!mainObject?.is_nutri}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_nutri: !!c
              });
            }}
          />
        </Grid>}
        {((login?.practice_id || currentPractice?.id) === 4 || (login?.practice_id || currentPractice?.id) === 13 || (login?.practice_id || currentPractice?.id) === 455) && <Grid item xs={12} md={4}>
          <Switcher
            id="is_it"
            caption={t("general.knowledge_courses.fields.is_it")}
            value={!!mainObject?.is_it}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_it: !!c
              });
            }}
          />
        </Grid>}
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.payment")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            id="cost"
            caption={t("general.knowledge_courses.fields.cost")}
            value={mainObject.mollie_data?.cost || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                mollie_data: {
                  ...(mainObject?.mollie_data || {}),
                  cost: !!e ? e.replace(/[^0-9\,\.]/g, '').replace(",", ".") : '0.0'
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Switcher
            id="immediate_payment"
            caption={t("general.knowledge_courses.fields.immediate_payment")}
            disabled={!currentPractice?.settings?.mollie_api_key}
            value={parseInt(mainObject?.mollie_data?.immediate_payment?.toString() || '0', 10) === 1}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                mollie_data: {
                  ...(mainObject?.mollie_data || {}),
                  immediate_payment: !!c ? 1 : 0
                }
              });
            }}
          />
          {!currentPractice?.settings?.mollie_api_key && <Typography variant="caption"sx={{color: theme.palette.secondary.main}}>{t("general.knowledge_courses.mollie_enabled_error")}</Typography>}
        </Grid>
        <Grid item xs={12} sx={{marginBottom: 1, marginTop: 1}}>
          <Typography variant="subtitle1">{t("general.knowledge_courses.fields.coupons")}</Typography>
        </Grid>
        {(mainObject?.mollie_data?.coupons || []).map((cpn, ii) => <>
          <Grid item xs={1}>
            <IconButton
              onClick={() => {
                setMainObject({
                  ...mainObject,
                  mollie_data: {
                    ...(mainObject?.mollie_data || {}),
                    coupons: ((mainObject?.mollie_data || {}).coupons || []).filter((fff, iii) => iii !== ii)
                  }
                });
              }}
              sx={{
                marginTop: '30px'
              }}
            >
              <DeleteForever />
            </IconButton>
          </Grid>
          <Grid item xs={4}>
            <TextInput
              id="coupon"
              caption={t("general.knowledge_courses.fields.coupon_name")}
              value={cpn.name || ''}
              onChange={(e) => {
                let tmp = (mainObject?.mollie_data?.coupons || [])[ii];
                tmp.name = e;
                let newCoupons = [...(mainObject?.mollie_data?.coupons || [])];
                newCoupons[ii] = tmp;

                setMainObject({
                  ...mainObject,
                  mollie_data: {
                    ...(mainObject?.mollie_data || {}),
                    coupons: newCoupons
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextInput
              id="coupon"
              caption={t("general.knowledge_courses.fields.coupon_percentage")}
              value={cpn.perc?.toString() || ''}
              onChange={(e) => {
                let tmp = (mainObject?.mollie_data?.coupons || [])[ii];
                tmp.perc = parseInt(e, 10);
                let newCoupons = [...(mainObject?.mollie_data?.coupons || [])];
                newCoupons[ii] = tmp;

                setMainObject({
                  ...mainObject,
                  mollie_data: {
                    ...(mainObject?.mollie_data || {}),
                    coupons: newCoupons
                  }
                });
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption">{t("general.knowledge_courses.fields.coupon_maxvalid")}</Typography>
            <DatePicker
              label={t("general.knowledge_courses.fields.coupon_maxvalid")}
              disablePast
              openTo="year"
              format="DD"
              noIcon
              views={["year", "month", "day"]}
              id="coupon_maxvalid"
              value={cpn.date || DateTime.now().plus({years: 1}).toFormat("dd/LL/y")}
              setValue={(v) => {
                let tmp = (mainObject?.mollie_data?.coupons || [])[ii];
                tmp.date = v;
                let newCoupons = [...(mainObject?.mollie_data?.coupons || [])];
                newCoupons[ii] = tmp;

                setMainObject({
                  ...mainObject,
                  mollie_data: {
                    ...(mainObject?.mollie_data || {}),
                    coupons: newCoupons
                  }
                });
              }}
              sx={{field: {marginTop: 0}}}
            />
          </Grid>
        </>)}
        <Grid item xs={12}>
          <Button
            label={t("shared.buttons.add_coupon")}
            size='small'
            id='add_coupon'
            contained
            onClick={(v) => {
              setMainObject({
                ...mainObject,
                mollie_data: {
                  ...(mainObject?.mollie_data || {}),
                  coupons: [...((mainObject?.mollie_data || {}).coupons || []), {name: '', perc: 100, date: DateTime.now().plus({years: 1}).toFormat("dd/LL/y")}]
                }
              });
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />
        </Grid>



        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.access")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.segment_id")}
            backend
            displayEmpty
            id="segment_id"
            value={mainObject.segment_id?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                segment_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            {(segments || []).map(segment => <MenuItem value={segment.id}>{segment.name}</MenuItem>)}
          </Select>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="caption">{t("general.knowledge_courses.fields.availability")}</Typography><br/>
          <ButtonGroup>
            {HelpersLanguage.available_locales().map((locale, i) => <Btn variant={(mainObject.access_data?.availability || [1]).indexOf(HelpersLanguage.mapping_to_id(locale)) > -1 ? "contained" : "outlined"} onClick={() => {
              if ((mainObject.access_data?.availability || [1]).indexOf(HelpersLanguage.mapping_to_id(locale)) > -1) {
                setMainObject({
                  ...mainObject,
                  access_data: {
                    ...(mainObject?.access_data || {}),
                    availability: ((mainObject.access_data?.availability || [1]).filter(fff => fff !== HelpersLanguage.mapping_to_id(locale)) || [1])
                  }
                });
              } else {
                setMainObject({
                  ...mainObject,
                  access_data: {
                    ...(mainObject?.access_data || {}),
                    availability: [...(mainObject.access_data?.availability || [1]), HelpersLanguage.mapping_to_id(locale)]
                  }
                });
              }
            }}>{locale.toUpperCase()}</Btn>)}
          </ButtonGroup>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            id="months_available"
            caption={t("general.knowledge_courses.fields.months_available")}
            value={mainObject?.access_data?.months_available?.toString() || "0"}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                access_data: {
                  ...(mainObject?.access_data || {}),
                  months_available: !!e ? parseInt(e, 10) : 0
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.subjects")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6}>
          <Switcher
            id="is_open_order"
            caption={t("general.knowledge_courses.fields.is_open_order")}
            value={!!mainObject?.is_open_order}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_open_order: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("coach.models.knowledge_subjects.numerals")}
            displayEmpty
            id="numerals"
            value={mainObject.extra_data?.numerals || 'normal'}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                extra_data: {
                  ...(mainObject?.extra_data || {}),
                  numerals: v?.toString()
                }
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            <MenuItem value='normal'>1. 2. 3. 4. 5.</MenuItem>
            <MenuItem value='roman'>I. II. III. IV. V.</MenuItem>
            <MenuItem value='romansmall'>i. ii. iii. iv. v.</MenuItem>
            <MenuItem value='alphabet'>A. B. C. D. E.</MenuItem>
            <MenuItem value='alphabetsmall'>a. b. c. d. e.</MenuItem>
          </Select>
        </Grid>
        {/* <Grid item xs={12}>
            [...subjects...]
        </Grid> */}
        <Grid item xs={12} sx={{marginTop: 4}}>
          <Typography variant="h5">{t("coach.submenu.course_sections.finish")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_emails"
            caption={t("general.knowledge_courses.fields.is_emails")}
            value={!!mainObject?.is_emails}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_emails: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Switcher
            id="is_approvable"
            caption={t("general.knowledge_courses.fields.is_approvable")}
            value={!!mainObject?.is_approvable}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_approvable: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.review_id")}
            backend
            displayEmpty
            id="review_id"
            value={mainObject.review_id?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                review_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            {(questionnaires || []).filter(fff => fff.content_type === 'review').map(questionnaire => <MenuItem value={questionnaire.id}>{questionnaire.name}</MenuItem>)}
          </Select>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("general.knowledge_courses.fields.quiz_id")}
            backend
            displayEmpty
            id="quiz_id"
            value={mainObject.quiz_id?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                quiz_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value=''>--- ---</MenuItem>
            {(questionnaires || []).filter(fff => fff.content_type === 'quiz').map(questionnaire => <MenuItem value={questionnaire.id}>{questionnaire.name}</MenuItem>)}
          </Select>
        </Grid>
        







        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          {Object.values(isUploading || {}).filter(fff => !!fff).length > 0 && <Typography sx={{
            color: theme.palette.warning.main,
            fontStyle: 'italic',
            fontSize: '0.9rem',
          }}>{t("general.chunked_uploader.warning.active_upload")}</Typography>}

          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={Object.values(isUploading || {}).filter(fff => !!fff).length > 0 || Object.values(mainObject.full_name || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_body || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_teaser || {}).filter(fff => !!fff).length < 1}
            contained
            onClick={(v) => {
              saveObject(false);
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {Object.values(isUploading || {}).filter(fff => !!fff).length > 0 && !mutationSave.isPending && <Button
            label={t("shared.buttons.save_anyway")}
            id='save_anyway'
            disabled={Object.values(mainObject.full_name || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_body || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_teaser || {}).filter(fff => !!fff).length < 1}
            contained
            onClick={(v) => {
              saveObject(false);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
          {Object.values(isUploading || {}).filter(fff => !!fff).length < 1 && !mutationSave.isPending && <Button
            label={t("shared.buttons.save_keep_open")}
            id='save_opened'
            disabled={Object.values(isUploading || {}).filter(fff => !!fff).length > 0 || Object.values(mainObject.full_name || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_body || {}).filter(fff => !!fff).length < 1 || Object.values(mainObject.full_teaser || {}).filter(fff => !!fff).length < 1}
            contained
            onClick={(v) => {
              saveObject(true);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              if (!!isReturn) {
                navigate(`/knowledge_course/${mainObject.id}/builder`);
              } else {
                navigate("/knowledge_courses");
              }
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>
      </Grid>
    </Paper>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
